import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DMSIDS } from "models";
import { DMSv3SettingsDashboardQueryKeys } from "modules/DMSv3/Settings/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteLocationMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async dealer_location_id =>
      (
        await ApiInstance.post(
          `/config/location/update`,
          { dealer_location_id, dsn: "", dms_databases: "", dms_location_ids: "", dms_write_back: false, dms_id: DMSIDS.UNKNOWN },
          ENV.dmsv3BaseURL
        )
      ).data,
    onSuccess: () => typedQueryClient.invalidateQueries(DMSv3SettingsDashboardQueryKeys.dealers)
  });
